import { render, staticRenderFns } from "./brandTrainingRetailerAddStep2Dialog.vue?vue&type=template&id=38ff8782&scoped=true"
import script from "./brandTrainingRetailerAddStep2Dialog.vue?vue&type=script&lang=js"
export * from "./brandTrainingRetailerAddStep2Dialog.vue?vue&type=script&lang=js"
import style0 from "./brandTrainingRetailerAddStep2Dialog.vue?vue&type=style&index=0&id=38ff8782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff8782",
  null
  
)

export default component.exports